/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum CompanyType{
  customer = 'customer',
  forwarder = "forwarder",
  service_provider = "service_provider",
  customer_with_fleet = "customer_with_fleet"
}
